import Vue from "vue";
import Router from "vue-router";
import Layout from "../views/Layout.vue";
import LoginView from "../views/Login.vue";
import CheckOrderView from "../views/CheckOrder.vue";
import DashboardView from "../views/Dashboard.vue";
import OrdersView from "../views/Orders.vue";
import CompletedOrdersView from "../views/CompletedOrders.vue";
import ApiOrderAllocationView from "../views/ApiOrderAllocation.vue";
import OrderDetailView from "../views/OrderDetail.vue";
import OperationLogsView from "../views/OperationLogs.vue";
import UsersView from "../views/Users.vue";
import CouriersView from "../views/Couriers.vue";
import BusinessTypesView from "../views/BusinessTypes.vue";
import ProductsView from "../views/Products.vue";
import AdminRelationsView from "../views/AdminRelations.vue";
import IpBlacklistView from "../views/IpBlacklist.vue";
import LoginAlertsView from "../views/LoginAlerts.vue";
import LoginLogsView from "../views/LoginLogs.vue";
import ManualOrderSettingsView from "../views/ManualOrderSettings.vue";
import PaymentTypesView from "../views/PaymentTypes.vue";
import OrderSourcesView from "../views/OrderSources.vue";
import UpstreamAppsView from "../views/UpstreamApps.vue";
import UpstreamApiLogsView from "../views/UpstreamApiLogs.vue";
import ProfileView from "../views/Profile.vue";
import SmsSendLogsView from "../views/SmsSendLogs.vue";
import SmsTemplatesView from "../views/SmsTemplates.vue";
import AttachmentRetentionView from "../views/AttachmentRetention.vue";
import SystemSettingsView from "../views/SystemSettings.vue";
import { getStoredUser, hasRole } from "../utils/auth";

Vue.use(Router);

const router = new Router({
  mode: "hash",
  routes: [
    { path: "/login", component: LoginView },
    { path: "/checkOrder", component: CheckOrderView, meta: { public: true } },
    { path: "/checkOrder/:code", component: CheckOrderView, meta: { public: true } },
    {
      path: "/",
      component: Layout,
      redirect: "/dashboard",
      children: [
        { path: "dashboard", component: DashboardView, meta: { roles: ["super_admin", "admin", "sales"] } },
        { path: "orders", component: OrdersView, meta: { roles: ["super_admin", "admin", "sales"] } },
        { path: "completed-orders", component: CompletedOrdersView, meta: { roles: ["super_admin", "admin", "sales"] } },
        { path: "api-order-allocation", component: ApiOrderAllocationView, meta: { roles: ["super_admin", "admin", "sales"] } },
        { path: "orders/:id", component: OrderDetailView, meta: { roles: ["super_admin", "admin", "sales"] } },
        { path: "operation-logs", component: OperationLogsView, meta: { roles: ["super_admin", "admin"] } },
        { path: "users", component: UsersView, meta: { roles: ["super_admin", "admin"] } },
        { path: "couriers", component: CouriersView, meta: { roles: ["super_admin", "admin"] } },
        { path: "admin-relations", component: AdminRelationsView, meta: { roles: ["super_admin"] } },
        { path: "ip-blacklist", component: IpBlacklistView, meta: { roles: ["super_admin"] } },
        { path: "login-logs", component: LoginLogsView, meta: { roles: ["super_admin"] } },
        { path: "login-alerts", component: LoginAlertsView, meta: { roles: ["super_admin"] } },
        { path: "business-types", component: BusinessTypesView, meta: { roles: ["super_admin", "admin"] } },
        { path: "products", component: ProductsView, meta: { roles: ["super_admin", "admin"] } },
        { path: "payment-types", component: PaymentTypesView, meta: { roles: ["super_admin", "admin"] } },
        { path: "order-sources", component: OrderSourcesView, meta: { roles: ["super_admin", "admin"] } },
        { path: "upstream-apps", component: UpstreamAppsView, meta: { roles: ["super_admin", "admin"] } },
        { path: "upstream-api-logs", component: UpstreamApiLogsView, meta: { roles: ["super_admin", "admin"] } },
        { path: "sms-templates", component: SmsTemplatesView, meta: { roles: ["super_admin"], usernames: ["admin"] } },
        { path: "sms-send-logs", component: SmsSendLogsView, meta: { roles: ["super_admin", "admin"] } },
        { path: "attachment-retention", component: AttachmentRetentionView, meta: { roles: ["super_admin"] } },
        { path: "manual-order-settings", component: ManualOrderSettingsView, meta: { roles: ["super_admin"] } },
        { path: "system-settings", component: SystemSettingsView, meta: { roles: ["super_admin", "admin"] } },
        { path: "profile", component: ProfileView, meta: { roles: ["super_admin", "admin", "sales"] } },
      ],
    },
  ],
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((item) => item.meta?.public)) {
    next();
    return;
  }
  const token = localStorage.getItem("ps_token");
  const currentUser = getStoredUser();
  if (to.path !== "/login" && !token) {
    next("/login");
    return;
  }
  if (to.path === "/login" && token) {
    next("/dashboard");
    return;
  }
  const requiredRoles = to.matched.map((item) => item.meta?.roles).find((roles) => Array.isArray(roles));
  if (requiredRoles && !hasRole(currentUser, requiredRoles)) {
    localStorage.removeItem("ps_token");
    localStorage.removeItem("ps_user");
    next("/login");
    return;
  }
  const requiredUsernames = to.matched.map((item) => item.meta?.usernames).find((usernames) => Array.isArray(usernames));
  if (requiredUsernames && !requiredUsernames.includes(currentUser.username)) {
    localStorage.removeItem("ps_token");
    localStorage.removeItem("ps_user");
    next("/login");
    return;
  }
  next();
});

export default router;
